import { render, staticRenderFns } from "./daipi.vue?vue&type=template&id=13ba9e5e&scoped=true&"
import script from "./daipi.vue?vue&type=script&lang=js&"
export * from "./daipi.vue?vue&type=script&lang=js&"
import style0 from "./daipi.vue?vue&type=style&index=0&id=13ba9e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba9e5e",
  null
  
)

export default component.exports